import Tooltip from "@mui/material/Tooltip";

import { ZoneDTO } from "../../DTOs/ZoneDTO";
import { getContrastTextColor } from "../../utilities/helpers/getContrastTextColor";

export type ZoneLabel = Pick<ZoneDTO, "zone" | "hexColour">;

/** Black or white, whichever the zone's own colour reads against, whatever the app theme is. */
export const zoneTooltipColours = (zoneColour: string) => {
  const background = getContrastTextColor(zoneColour);

  return { background, label: background === "#000000" ? "#ffffff" : "#000000" };
};

export function ZoneTooltip({ zone, children }: { zone?: ZoneLabel; children: React.ReactElement }) {
  if (!zone) return children;

  const { background, label } = zoneTooltipColours(zone.hexColour);

  return (
    <Tooltip
      arrow
      placement="top"
      slotProps={{
        popper: { modifiers: [{ name: "offset", options: { offset: [0, -14] } }] },
        tooltip: {
          sx: {
            bgcolor: background,
            border: "1px solid var(--color-theme-border)",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px -1px 8px",
          },
        },
        arrow: { sx: { color: background } },
      }}
      title={
        <>
          <span style={{ color: label }}>Zone: </span>
          <span className="font-bold" style={{ color: zone.hexColour }}>{zone.zone}</span>
        </>
      }
    >
      {children}
    </Tooltip>
  );
}
